module.exports = __webpack_public_path__ + "static/media/guy2.1582a3d2.png";